import { Injector } from "@/services/injector/injector";
import type { InjectionKey } from "vue";

export const INJECTOR_SERVICE_INJECTION_KEY: InjectionKey<Injector> =
  Symbol("INJECTOR_SERVICE");
